export default "__VITE_ASSET__DP2iSbZH__"